import { Button, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import SelectEmpleadoAlta from './SelectEmpleadoAlta';
import TablaDetallesIncidencias from '../lote/TablaDetallesIncidencias';
import { useSelector } from 'react-redux'
import SwitchStatusLote from '../lote/SwitchStatusLote';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import { useSnackbar } from 'notistack';
import BotonResuemenPDF from '../lote/BotonResuemenPDF';
import useSubmitLock from '../../../hooks/useSubmitLock';

const { REACT_APP_API_URL } = process.env;

const SeleccionEmpleados = (props) => {

    const { enqueueSnackbar } = useSnackbar();

    const { lote } = props
    const { bd } = props
    const { depta } = props
    const { periodo } = props
    const { detalle } = props
    const { pdim } = props
    const { obtenerdatolote } = props
    const { obtenerincidenciasxlote } = props
    const datogeneral = useSelector(store => store.lote.incidencias) || [];

    const nivelpri = sessionStorage.getItem('_sr3')
    const nivelprinum = parseInt(nivelpri)
    const { submitting, runWithSubmitLock } = useSubmitLock()
    const notificacion = (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });
    };
    const notificacion2 = async (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        await enqueueSnackbar(msg, { variant });
        window.location.reload()
    };
    const aprobarlote = () => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify({
            "idlote": lote
        });
        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        try {
            const response = await fetch(`${REACT_APP_API_URL}/lotes/aprobar`, requestOptions)
            const resultado = await response.json();
            return (obtenerdatolote(lote), notificacion(resultado))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
    })

    const desaprobarlote = () => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify({
            "idlote": lote
        });
        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        try {
            const response = await fetch(`${REACT_APP_API_URL}/lotes/desaprobar`, requestOptions)
            const resultado = await response.json();
            return (obtenerdatolote(lote), notificacion(resultado))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
    })

    const sincronizarlote = () => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify({
            "guidempresa": datogeneral.guidempresa,
            "idlote": lote
        });
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        try {
            const response = await fetch(`${REACT_APP_API_URL}/lotes/sincronizar`, requestOptions)
            const resultado = await response.json();
            return (obtenerdatolote(lote), notificacion2(resultado))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
    })

    if (detalle === true) {
        return (
            <div style={{ paddingTop: '6px' }}>
                <Grid container spacing={3}>
                    <Grid item md={6}>
                        <Typography>{datogeneral.idlote}</Typography>
                        <SwitchStatusLote
                            detalle={true}
                            status={datogeneral.estatus}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <Typography align='right'><b>Departamento:</b>{datogeneral.descdepto}</Typography>
                        <Typography align='right'>
                            <b>Periodo:</b>  {datogeneral.numeroperiodo}
                        </Typography>
                        <Typography align='right'>
                            <b>Inicio:</b>{datogeneral.fechainicio}
                        </Typography>
                        <Typography align='right'>
                            <b>Termina:</b>  {datogeneral.fechafin}
                        </Typography>
                    </Grid>

                </Grid>

                <Divider />
                <br />
                <Grid container flexDirection='column' spacing={3} sx={{ minHeight: '68vh' }} >
                    <Grid item>
                        {datogeneral.estatus === 'Creado' ? <SelectEmpleadoAlta
                            lote={lote}
                            empresa={bd}
                            depta={depta}
                            periodo={periodo}
                            detalle={detalle}
                        /> : null}
                        <Button color='success' variant='text' onClick={e => obtenerdatolote(lote)}>Actualizar datos</Button>
                    </Grid>
                    <Grid item>
                        <TablaDetallesIncidencias
                            datogeneral={pdim}
                            obtenerdatolote={obtenerdatolote}
                            lote={lote}
                            estatus={datogeneral.estatus}
                        />
                    </Grid>

                </Grid>
                <Grid container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-end"
                    spacing={2}
                >
                    {datogeneral.estatus === 'Creado' ?
                        nivelpri !== '3' ?
                            <Grid item>
                                < Button disabled={pdim.length === 0 || submitting}
                                    onClick={e => aprobarlote()} variant='contained' color='success' ><AssignmentTurnedInIcon /> APROBAR</Button>

                            </Grid> : null : null}
                    {datogeneral.estatus === 'Aprobado' ?
                        nivelpri !== '3' ?
                            <Grid item>
                                <Button onClick={e => desaprobarlote()} variant='contained' color='success' disabled={submitting}><AssignmentReturnedIcon />DESAPROBAR</Button>

                            </Grid> : null : null}
                    {datogeneral.estatus === 'Aprobado' ?
                        nivelprinum >= 13 ?
                            <Grid item>
                                <Button onClick={e => sincronizarlote()} variant='contained' color='success' disabled={submitting}><CheckCircleOutlineIcon />SINCRONIZAR</Button>
                            </Grid> : null : null}
                    <Grid item>
                        {datogeneral.estatus === 'Sincronizado' ?
                            <BotonResuemenPDF
                                lote={lote}
                                detalle={true}
                            /> : null
                        }
                    </Grid>
                </Grid>
            </div >
        )
    } else {
        return (
            <div>
                <Typography variant='h5'>
                    Selección de empleados
                </Typography>

                <Grid container spacing={3}>
                    <Grid item md={6}>

                        <Typography>{datogeneral.idlote}</Typography>

                        <SwitchStatusLote
                            detalle={true}
                            status={datogeneral.estatus}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <Typography align='right'><b>Departamento:</b>{datogeneral.descdepto}</Typography>
                        <Typography align='right'>
                            <b>Periodo:</b>  {datogeneral.numeroperiodo}
                        </Typography>
                        <Typography align='right'>
                            <b>Inicio:</b>{datogeneral.fechainicio}
                        </Typography>
                        <Typography align='right'>
                            <b>Termina:</b>  {datogeneral.fechafin}
                        </Typography>
                    </Grid>
                </Grid>
                <Divider />
                <br />
                <Grid container flexDirection='column' spacing={3}>
                    <Grid item>
                        <SelectEmpleadoAlta
                            lote={lote}
                            empresa={bd}
                            depta={depta}
                            periodo={periodo}
                        />
                        <Button color='success' onClick={e => obtenerincidenciasxlote(lote)}>Actualizar datos</Button>
                    </Grid>
                    <Grid item>
                        <>
                            {datogeneral === undefined ? null
                                : < TablaDetallesIncidencias
                                    datogeneral={datogeneral.pdim}
                                    obtenerdatolote={obtenerincidenciasxlote}
                                    lote={lote}
                                    estatus={datogeneral.estatus}
                                />
                            }
                        </>


                    </Grid>
                </Grid>
                <br />
                <Grid container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-end"
                    spacing={2}
                >
                    {datogeneral.estatus === 'Creado' ?
                        nivelpri !== '3' ?

                            <Grid item>
                                < Button disabled={datogeneral.pdim.length === 0 || submitting}
                                    onClick={e => aprobarlote()} variant='contained' color='success' ><AssignmentTurnedInIcon /> APROBAR</Button>
                            </Grid> : null : null}
                    {datogeneral.estatus === 'Aprobado' ?
                        nivelpri !== '3' ?
                            <Grid item>
                                <Button onClick={e => desaprobarlote()} variant='contained' color='success' disabled={submitting}><AssignmentReturnedIcon />DESAPROBAR</Button>
                            </Grid> : null : null}
                    {/* {datogeneral.estatus === 'Aprobado' ?
                        nivelprinum >= 13 ?
                            <Grid item>
                                <Button onClick={e => sincronizarlote()} variant='contained' color='success' disabled={false}><CheckCircleOutlineIcon />SINCRONIZAR</Button>
                            </Grid> : null : null} */}

                    {datogeneral.estatus === 'Sincronizado' ?
                        <Grid item>

                            <BotonResuemenPDF
                                lote={lote}
                                detalle={true}
                            />
                        </Grid> : null
                    }
                </Grid>
            </div>
        )
    }
}

export default SeleccionEmpleados